<template>
  <b-card>
    <div class="card-h d-flex justify-content-between  align-items-center">
      <div class="title">
        {{ title }}
      </div>
      <slot name="title" />
      <b-button
        v-if="showBack"
        variant="dark"
        @click="goBack"
      >
        {{ $t('forms.back') }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'

export default {
  name: 'HeaderCard',
  components: {
    BCard, BButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    routeUrl: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goBack() {
      this.$router.push(this.routeUrl)
    },
  },
}
</script>
<style lang="scss" scoped>
.card-h {
  border-bottom: 2px solid var(--seperator-color);
  .title {
    font-size: 20px;
    line-height: 1.2;
    color: var(--purple);
    font-weight: 600;
  }
}
</style>
